/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_FeaturedInputs */

const en_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const es_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

const fr_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En vedette`)
};

const de_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hervorgehoben`)
};

const ja_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おすすめ`)
};

const zh_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

const ar_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مميز`)
};

const id_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggulan`)
};

const it_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Evidenza`)
};

const ru_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемое`)
};

const pt_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaque`)
};

const ko_badge_featured = /** @type {(inputs: Badge_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Badge_FeaturedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_featured = /** @type {((inputs?: Badge_FeaturedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_FeaturedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_featured(inputs)
	if (locale === "es") return es_badge_featured(inputs)
	if (locale === "fr") return fr_badge_featured(inputs)
	if (locale === "de") return de_badge_featured(inputs)
	if (locale === "ja") return ja_badge_featured(inputs)
	if (locale === "zh") return zh_badge_featured(inputs)
	if (locale === "ar") return ar_badge_featured(inputs)
	if (locale === "id") return id_badge_featured(inputs)
	if (locale === "it") return it_badge_featured(inputs)
	if (locale === "ru") return ru_badge_featured(inputs)
	if (locale === "pt") return pt_badge_featured(inputs)
	return ko_badge_featured(inputs)
});